export default {
  // Endpoints
  // loginEndpoint: '/jwt/login',
  // registerEndpoint: '/jwt/register',
  // refreshEndpoint: '/jwt/refresh-token',
  // logoutEndpoint: '/jwt/logout',
  loginEndpoint: 'https://api.sabaideelotto.com/api/auth/login',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: 'https://api.sabaideelotto.com/api/auth/refresh-token',
  logoutEndpoint: 'https://api.sabaideelotto.com/api/auth/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'token',
  storageRefreshTokenKeyName: 'refreshToken',
}
